
<template>
<tr v-bind:class="{ 'line-group': line.epic }" v-show="line.epic || line.story || line.group">

	<th v-if="line.group">
		<i class="fa fa-grip-lines float-left dragRow"></i>
        <span class="tag truncate">{{line.group.text}}<i class="mi close" @click="confirmRemoveGroup(line.group.id)"></i></span>
	</th>

    <th :alt="line.epic.title" class="line-heading" v-else-if="line.epic">
        <div class="row">
            <div class="col-md-12">
                <input style="display:inline" type="text" class="form-control" v-model="epic.title" @change="epicUpdated">
            </div>
        </div>

	</th>

    <th :alt="line.story.title" class="line-heading" v-else-if="line.story">
		<i class="fa fa-grip-lines float-left dragRow"></i>
        <input type="text" class="form-control" value="Business Review" v-model="line.story.title">
	</th>

	<th v-else>
		<span v-show="line.order == 0">{{line.name}}</span>
		<input class="form-input feature-name" v-model="line.name" @blur="save" v-show="line.order != 0">
        <span v-show="line.order != 0"><i class="mi close" @click="confirmRemoveFeature()"></i></span>
	</th>

	<td><input type="text" class="form-control" v-model="story.estimate" @change="hoursChanged" v-if="line.story"></td>
	<td class="minor">{{line.bugs}}</td>
	<td class="minor">{{line.management}}</td>
	<td class="strong">{{line.total_hours}}</td>
	<td  v-if="line.epic || line.group"></td>
	<td class="no-padding" v-else>
		<div class="input-group input-adjustment">
			<div class="input-group-addon">$</div>
			<input type="text" class="form-control width-md" v-model="line.adjustment" placeholder="0" @blur="save" />
		</div>
	</td>


	<td class="cost"><span class="float-left">$</span> {{line.total_ex | currency}}</td>

    <td class="options">
						<div class="dropdown">
							<button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<i class="fa fa-ellipsis-h"></i>
							</button>
							<div class="dropdown-menu" aria-labelledby="dropdownMenu1">
                <a v-if="line.epic" href="#" data-toggle="modal" v-bind:data-target="'#exampleModal'+line.epic.id">Description</a>
								<a href="#" class="dropdown-item" @click="deleteLine">Delete</a>
								<a href="#" class="dropdown-item">Duplicate</a>
							</div>
						</div><!-- /.dropdown -->



<!-- Modal -->
<div class="modal modal-material fade" v-bind:id="'exampleModal'+line.epic.id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="epic.id">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalLabel">Description</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <wysiwyg-inline :content="epic.description" :save="saveEpicDescription"></wysiwyg-inline>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
					</td>
</tr>
</template>

<script>
    //http://stackoverflow.com/documentation/javascript/4742/same-origin-policy-cross-origin-communication/30128/safe-cross-origin-communication-with-messages#t=201705171403471400655
//<div id="iframe-wrapper" style="position: absolute; width: 100%; height: 100%; top: 0px; background-color: #c3c3c3; z-index: 1000; opacity: 0.4;"><i class="fa fa-sticky-note" style=" font-size: 24px; z-index: 1005; position: absolute; top: 100px; left: 100px; color: red;"></i></div>
    import { mapState, mapActions } from 'vuex'
    import { Selectize, LaddaButton } from 'components/form/input'
    import Datepicker from 'vuejs-datepicker'
    import { notify } from 'utils'
    import { unset, cloneDeep } from 'lodash'
    import Story from './../../models/story.js'
    import { WysiwygInline } from 'components/form/input'

    export default {
        components: {
            LaddaButton,
            Datepicker,
            Selectize,
            WysiwygInline
        },

    	props: ['line', 'costing', 'project'],
        data: function () {
            return {
            	edit: false,
            	loading: false,
                users: [],
                epic: {},
                story: {},
                newUserStory: new Story(),
            }
        },

        mounted: function() {
            if (this.line.epic) {
                this.epic = cloneDeep(this.line.epic)
            }

            this.story = cloneDeep(this.line.story)
        },

        computed: {
        	'api': function() {
        		return process.env.VUE_APP_API_URL;
			},
			order () {
				return this.index + 1
			}

        },
        methods: {
            ...mapActions('epics', ['updateEpic', 'addUserStory', 'updateUserStory']),
            epicUpdated(value) {

                this.updateEpic({ docId: this.costing.user_story_document_id, epicId: this.epic.id, payload: this.epic}).then( () => {
                    this.$emit('epicUpdated')
                })


            },
            handleCreateUserStory () {

				this.newUserStory.epic_id = this.epic.id
				delete this.newUserStory.order
				//this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)

				this.addUserStory({
					id: this.costing.user_story_document_id,
					index: null,
					payload: this.newUserStory
				}).then((response) => {

					//reset the form data
                    this.newUserStory = new Story()

                    //this.$bus.$emit('reload')
					//this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
				}).catch((response) => {
					notify.error('There was an issue trying to create your user story!')
					//this[SET_SAVE_STATUS](AppConstants.save_status.ERROR_SAVING)
				})
			},
            save: function() {

            	 var that = this;
                this.loading = true;

                return client({path: '/projects/'+this.project.id+'/costing/'+this.costing.id+'/line/'+this.line.id, entity: this.line, method: 'PUT'}).then(
                    function(response) {
                    	that.$bus.$emit('reload')
                    },
                    function(response) {

                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                        } else {

                        }
                    }

                )

            	this.edit = false;
            },
            hoursChanged: function(value) {

                this.updateUserStory({
                    docId: this.costing.user_story_document_id,
                    storyId: this.story.id,
					payload: {complexity: 1, estimate: this.story.estimate, title: this.story.title}
				}).then((response) => {

					//reset the form data
                    //this.newUserStory = new Story()

                    this.$bus.$emit('reload')
					//this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
				}).catch((response) => {
					notify.error('There was an issue trying to create your user story!')
					//this[SET_SAVE_STATUS](AppConstants.save_status.ERROR_SAVING)
				})
            },
            deleteLine: function() {
                var that = this;

                return client({path: '/projects/'+this.project.id+'/costing/'+this.costing.id+'/line/'+this.line.id, entity: this.line, method: 'DELETE'}).then(
                    function(response) {
                    	that.$bus.$emit('reload')
                    }

                )
            },
            saveEpicDescription: function(description) {

                this.epic.description = description

                return client({path: '/user-story-document/'+this.costing.user_story_document_id+'/epics/'+this.line.epic.id, entity: this.epic, method: 'PUT'}).then(
                    function(response) {

                    }

                )
            }
        }
    }
</script>

<style scoped>
.modal {
  text-align: center;
}

@media screen and (min-width: 768px) {
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.ck-content { width:650px; }
</style>
